module.exports = __webpack_public_path__ + "img/icons_40.cf8020f7.svg";